export default "__VITE_ASSET__DLz$sKlk__"